const config = {
    app: {
        useFirebase: true,
        version: "1.0.0"
    },
    firebaseConfig: {
        shipsCollectionName: "Ships",
        shipTypesCollectionName: "ShipTypes",
        shipModificationsName: "ShipModifications",
        parametricTablesCollectionName: "ParametricTables",
        usersCollectionName: "Users",
        parametricVersion: "v2",
        fuelTypesCollectionName : "FuelTypes"
    }
}

exports.config = config
